import React, { Component } from 'react';
import ReactTable from "react-table";
import { withRouter } from 'react-router-dom';
import couterpart from 'counterpart';

import DatePicker from 'react-datepicker';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Spinner from 'react-spinner-material';
import { FaFilter } from 'react-icons/fa';

import { MdImportExport } from 'react-icons/md';
import Dialog from 'react-bootstrap-dialog';

import {MdModeEdit, MdDeleteForever} from 'react-icons/md';

import { SEVERITY_URGENT, WO_ADMIN_APPROVED } from '../constants';

import MenuComponent2 from './MenuComponent2';
// import ReactTablePagination from './PaginationComponent';

import { DATA_TYPE_DESIGN } from '../constants';

import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';
import UserDataService from '../services/UserDataService';
import ItemDataService from '../services/ItemDataService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

import "react-table/react-table.css";
import "../css/style.css";
import {  ICON_COLOR } from '../icon';

class WorkOrderList extends Component {
  constructor () {
    super();
    let fromDate = new Date(new Date().getTime() - 12*30*24*60*60*1000);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    let fromDeadlineDate = toDate;

    this.state = {
      didMounted: false,
      spinnerVisible: false,
      fromDate: fromDate,
      toDate: toDate,
      fromDeadlineDate: fromDeadlineDate,
      allStatus: [],
      selected: null,
      workOrders: [],
      selectedPage: 0,
      selectedRow: 0,
      selectAll: 0,
      selected: [],
      page: 0,
      pageSize: 20,
      sku: '',
      items: [],
      columns : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },          
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selected[original.id] && this.state.selected[original.id].checked === true}
                onChange={() => this.toggleRow(original)}
              /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        // },{
        //     Header: couterpart.translate('work_order_no'),
        //     accessor: 'id',
        //     width: 50  
        },{
          Header: couterpart.translate('work_order_urgent_level'),
          accessor: 'isUrgentByCustomer',
          Cell: row => {
            row.styles['color'] = row.value === 1 ? 'red' : 'black';
            return row.value === 1 ? 'X' : '';
          },          
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)                    
        },{
            Header: couterpart.translate('work_order_no'),
            accessor: 'workOrderNo',
            width: 250,
            Cell: row =>(
              this.linkToDetails(row)
            )
        },{
          Header: couterpart.translate('work_order_code'),
          accessor: 'sku',
          width: 250,
          filterable: false           
        },{
          Header: couterpart.translate('shop_pcode'),
          accessor: 'fullPCode',
          filterable: false
        },{
            Header: couterpart.translate('work_order_quantity'),
            accessor: 'qty',
            width: 70
        },{
          Header: couterpart.translate('work_order_customer'),
          accessor: 'customer',
          filterable: false
        },{
            Header: 'MT',
            accessor: 'fimg',
            width: 200,
            Cell: row =>(
              this.fImageRender(row)
            )
        },{
            Header: 'MS',
            accessor: 'bimg',
            width: 200,
            Cell: row =>(
              this.bImageRender(row)
            )
        },{
          Header: couterpart.translate('work_order_order_date'),
          accessor: 'orderDate',
          filterable: false,
          width: 120   
        },{
          Header: couterpart.translate('work_order_prod_deadline'),
          accessor: 'prodDeadlineTs',
          filterable: false,
          width: 120                                                                           
        },{
            Header: couterpart.translate('work_order_ckExportFile'),
            accessor: 'ckExportFile',
            width: 250
        },{ 
          Header: couterpart.translate('work_ngay_nhap_lieu'),
          accessor: 'ngayNhapLieu',
          filterable: false,
          width: 120
        },{          
          Header: couterpart.translate('ship_to'),
          accessor: 'shipTo',
          width: 70
        }, {
          Header: couterpart.translate('wo_donmua'),
          accessor: 'donMua',
          filterable: false,
          width: 100
        }, {
          Header: couterpart.translate('wo_hangiaomua'),
          accessor: 'hanGiaoMua',
          filterable: false,
          width: 150                                       
        },{
          Header: couterpart.translate('work_order_status'),
          accessor: 'status',
          width: 250,
          Cell: props => this.getStatusDescription(props.value)    
        }
      ],
      columnsDesigner : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },          
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selected[original.id] && this.state.selected[original.id].checked === true}
                onChange={() => this.toggleRow(original)}
              /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        // },{
        //     Header: couterpart.translate('work_order_no'),
        //     accessor: 'id',
        //     width: 50  
        },{
          Header: couterpart.translate('work_order_urgent_level'),
          accessor: 'isUrgentByCustomer',
          Cell: row => {
            row.styles['color'] = row.value === 1 ? 'red' : 'black';
            return row.value === 1 ? 'X' : '';
          },          
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)                    
        },{
            Header: couterpart.translate('work_order_no'),
            accessor: 'workOrderNo',
            width: 250,
            Cell: row =>(
              this.linkToDetails(row)
            )
        },{
          Header: couterpart.translate('work_order_code'),
          accessor: 'sku',
          width: 250,
          filterable: false           
        },{
          Header: couterpart.translate('shop_pcode'),
          accessor: 'fullPCode',
          filterable: false
        },{
            Header: couterpart.translate('work_order_quantity'),
            accessor: 'qty',
            width: 70
        },{
          Header: couterpart.translate('work_order_customer'),
          accessor: 'customer',
          width: 150,
          filterable: false
        },{
          Header: couterpart.translate('work_order_personalization'),
          accessor: 'personalization',
          width: 350,
          filterable: false,
          wrap: true,
          Cell: row => (
            <div className='text-wrap'>
              {this.renderPersonalization(row)}
            </div>
          )
        },{
          Header: couterpart.translate('work_order_font'),
          accessor: 'font',
          filterable: false
        },{
          Header: couterpart.translate('work_order_size'),
          accessor: 'lengthSize',
          filterable: false 
        },{
            Header: 'MT',
            accessor: 'fimg',
            width: 200,
            Cell: row =>(
              this.fImageRender(row)
            )
        },{
            Header: 'MS',
            accessor: 'bimg',
            width: 200,
            Cell: row =>(
              this.bImageRender(row)
            )
        }, {
          Header: couterpart.translate('work_order_order_date'),
          accessor: 'orderDate',
          filterable: false,
          width: 120
        },{
          Header: couterpart.translate('work_order_prod_deadline'),
          accessor: 'prodDeadlineTs',
          filterable: false,
          width: 120                                                                           
        },{
            Header: couterpart.translate('work_order_ckExportFile'),
            accessor: 'ckExportFile',
            width: 250
        },{ 
          Header: couterpart.translate('work_ngay_nhap_lieu'),
          accessor: 'ngayNhapLieu',
          filterable: false,
          width: 120
        },{          
          Header: couterpart.translate('ship_to'),
          accessor: 'shipTo',
          width: 70
        }, {
          Header: couterpart.translate('wo_donmua'),
          accessor: 'donMua',
          filterable: false,
          width: 100
        }, {
          Header: couterpart.translate('wo_hangiaomua'),
          accessor: 'hanGiaoMua',
          filterable: false,
          width: 150                                       
        },{
          Header: couterpart.translate('work_order_status'),
          accessor: 'status',
          width: 250,
          Cell: props => this.getStatusDescription(props.value)    
        }
      ]
    };
  }

  loadItems(){
    ItemDataService.retrieveItems().then(data =>{
      // console.log('ITEMS', data)
      this.setState({ 
          items: data
      });
    });
  }

  toggleRow(row) {
    let newSelected = Object.assign({}, this.state.selected);
    if (newSelected[row.id] === undefined){
      newSelected[row.id] = {checked: true, status: row.status, shipCode: row.shipCode};
    }

    if (this.state.selected[row.id]){
      newSelected[row.id].checked = !this.state.selected[row.id].checked;
      newSelected[row.id].status = this.state.selected[row.id].status;
      newSelected[row.id].shipCode = this.state.selected[row.id].shipCode;
    }

		this.setState({
			selected: newSelected,
			selectAll: 2
		}, () =>{
      WorkOrderUtil.saveItem('wo.selected', JSON.stringify(this.state.selected));
    });
	}

	toggleSelectAll() {
		const newSelected = Object.assign({}, this.state.selected);
		if (this.state.selectAll === 0 || this.state.selectAll === undefined) {
			this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined){
          newSelected[x.id] = {checked: true, status: x.status, shipCode: x.shipCode};
        } else {        
          newSelected[x.id].checked = true;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
        }
			});
		} else {
			this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined){
          newSelected[x.id] = {checked: false, status: x.status, shipCode: x.shipCode};
        } else {        
          newSelected[x.id].checked = false;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
        }
			});
    }

		this.setState({
			selected: newSelected,
			selectAll: this.state.selectAll === 0 ? 1 : 0
		}, () =>{
      WorkOrderUtil.saveItem('wo.selected', JSON.stringify(this.state.selected));
    });
	}

  getStatusDescription(status){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return status;
    }    
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x =>{
      return x.status === istatus;
    });
    if (statusInfo !== undefined){
      return statusInfo.statusDescVn;
    }   
    return status;     
  }

  linkToDetails(row){
      return(
          <label className="label_link" href="#!" onClick={() => {this.handleEdit(row)}}>{row.original.workOrderNo}</label>
      )
  }

  renderPersonalization(row){
      return(
          <>{ row.original.personalization }</>
      )
  }

  fImageRender(row){
    if (row.original.fimg === undefined || row.original.fimg === null){
      return (<></>)
    }
    return(
        <img className="imageBox linkTo" alt="" width={ 100 } height={70} src={`data:image/jpeg;base64,${row.original.fimg}`} name={'F' + row.original.workOrderNo} />
    )
  }

  bImageRender(row){
    if (row.original.bimg === undefined || row.original.bimg === null){
      return (<></>)
    }    
    return(
        <img className="imageBox linkTo" alt="" width={ 100 } height={70} src={`data:image/jpeg;base64,${row.original.bimg}`} name={ 'B' + row.original.workOrderNo} />
    )
  }        


  renderEditButton(row){
    const button_view = couterpart.translate('button_view');
    const button_edit = couterpart.translate('button_edit');
    if (AuthenticationService.isAdmin() ||
      AuthenticationService.isService() ||
      AuthenticationService.isKhac() ||
      AuthenticationService.isShipping() ||
      AuthenticationService.isDesigner()){
      return (<div><button className="myButton"  onClick={() => this.handleEdit(row)}>
      <MdModeEdit color={ICON_COLOR}/>&nbsp;
      {button_edit}</button>&nbsp;</div>);
    }else{
      return (<div><button className="myButton" onClick={() => this.handleView(row)}>
      <MdDeleteForever color={ICON_COLOR}/>&nbsp;
      {button_view}</button></div>);
    }
  }

  componentDidMount () {
    // var userId = AuthenticationService.getUserId();

    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ allStatus:  data}) 
    });

    this.loadItems();

    let fromDate = WorkOrderUtil.getItem("wo.fromDate");
    let toDate = WorkOrderUtil.getItem("wo.toDate");
    let fromDeadlineDate = WorkOrderUtil.getItem("wo.fromDeadlineDate");
    const numOfMonths = 12;
    if (fromDate === null || fromDate === undefined) {
      fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000);//1 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date();
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    let tmp = WorkOrderUtil.getItem('wo.selectedPage');
    let iSelectPage = 0;
    if (tmp !== undefined) {
      iSelectPage = parseInt(tmp);
    }

    let selectedRow = WorkOrderUtil.getItem('wo.selectedRow') ? parseInt(WorkOrderUtil.getItem('wo.selectedRow')) : 0;
    let selectedWorkOrderId = WorkOrderUtil.getItem('wo.selectedWorkOrderId') ? parseInt(WorkOrderUtil.getItem('wo.selectedWorkOrderId')) : 0;
    let sincludeImage = WorkOrderUtil.getItem("wo.includeImage");
    let pcode =  WorkOrderUtil.getItem('wo.pcode')? WorkOrderUtil.getItem('wo.pcode') : '';
    let includeImage = 1;
    if (sincludeImage === '0'){
      includeImage = 0;
    }

    let sku = WorkOrderUtil.getItem('wo.sku');
    let onlyUrgent = WorkOrderUtil.getItem('wo.onlyUrgent');
    let donMuaSearch = WorkOrderUtil.getItem("shipOrders.donMuaSearch");
    let hanGiaoMuaSearch = WorkOrderUtil.getItem("shipOrders.hanGiaoMuaSearch");

    this.setState({ 
      fromDate:  fromDate, 
      toDate: toDate, 
      fromDeadlineDate: fromDeadlineDate,
      status: WorkOrderUtil.getItem("wo.status"), 
      country: WorkOrderUtil.getItem("wo.country"),
      customer: WorkOrderUtil.getItem("wo.customer"),
      orderNo: WorkOrderUtil.getItem("wo.orderNo"),
      woStatus: WorkOrderUtil.getItem("wo.woStatus"),
      selectedRow: selectedRow, 
      selectedWorkOrderId: selectedWorkOrderId, 
      selectedPage: iSelectPage,
      pages: 0,
      page: 0,
      didMounted: true,
      includeImage: includeImage,
      sku: sku,
      pcode: pcode,
      onlyUrgent: onlyUrgent,
      donMua: donMuaSearch,
      hanGiaoMua: hanGiaoMuaSearch
    }, () => {
      this.filterOrdersBy();
    });
  }

  filterOrdersBy(){
    if ((this.state.selectedPage < 0) || (this.state.pageSize < 0 || this.state.didMounted === false)){
      return;
    }
    this.setState({ loading: true });
    var fromDate = this.state.fromDate;
    var toDate = this.state.toDate;
    var status = this.state.status;
    var woStatus = this.state.woStatus;
    var country = this.state.country;
    var customer = this.state.customer;
    var orderNo = this.state.orderNo;
    let page = this.state.selectedPage;
    let pageSize = this.state.pageSize;
    let includeImage = this.state.includeImage;
    let sku = this.state.sku;
    let pcode = this.state.pcode;
    let onlyUrgent = this.state.onlyUrgent;
    let fromDeadlineDate = this.state.fromDeadlineDate;
    let donMuaSearch = this.state.donMuaSearch;
    let hanGiaoMuaSearch = this.state.hanGiaoMuaSearch;

    let info = WorkOrderDataService.initializeSearchInfo2(fromDate, toDate, status, country, customer, orderNo, woStatus, undefined, undefined, pcode, undefined, 
    undefined, undefined, pageSize, page, includeImage, sku, onlyUrgent, fromDeadlineDate, donMuaSearch, hanGiaoMuaSearch);
    try{
      WorkOrderDataService.fetchWorkOrders(info)
        .then(data => {
        if(data.message === undefined && data.data !== undefined &&  data.data instanceof Array){    
          this.setState({ workOrders:  data.data, spinnerVisible: false, loading: false, pages: data.pages, page: page, pageSize: pageSize},
          () => {
            this.saveSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus, page, includeImage, sku, pcode, onlyUrgent, fromDeadlineDate, donMuaSearch, hanGiaoMuaSearch);
          });
        }else{
          this.setState({ workOrders:  [], loading: false, pages: 0, page: 0, pageSize: pageSize});
          ToastsStore.error(data.message);
        }   
      });
    }catch(e){
       this.setState({ workOrders:  [], loading: false, pages: 0, page: 0, pageSize: pageSize});
    }
  }     

  clearSearchInfo() {
    WorkOrderUtil.removeItem("wo.fromDate");
    WorkOrderUtil.removeItem("wo.toDate");
    WorkOrderUtil.removeItem("wo.fromDeadlineDate");
    WorkOrderUtil.removeItem("wo.status");
    WorkOrderUtil.removeItem("wo.country");
    WorkOrderUtil.removeItem("wo.customer");
    WorkOrderUtil.removeItem("wo.orderNo");
    WorkOrderUtil.removeItem("wo.woStatus");
    WorkOrderUtil.removeItem("wo.page");
    WorkOrderUtil.removeItem("wo.selected");
    WorkOrderUtil.removeItem("wo.includeImage");
    WorkOrderUtil.removeItem("wo.sku");
    WorkOrderUtil.removeItem("wo.pcode");
    WorkOrderUtil.removeItem("wo.onlyUrgent");
    WorkOrderUtil.removeItem("wo.donMuaSearch");
    WorkOrderUtil.removeItem("wo.hanGiaoMuaSearch");
  }
  saveSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus, page, includeImage, sku, pcode, onlyUrgent, fromDeadlineDate, donMuaSearch, hanGiaoMuaSearch){
    WorkOrderUtil.saveItem("wo.fromDate", fromDate);
    WorkOrderUtil.saveItem("wo.toDate", toDate);
    WorkOrderUtil.saveItem("wo.fromDeadlineDate", fromDeadlineDate);  
    WorkOrderUtil.saveItem("wo.status", status);
    WorkOrderUtil.saveItem("wo.country", country);
    WorkOrderUtil.saveItem("wo.customer", customer);
    WorkOrderUtil.saveItem("wo.orderNo", orderNo);
    WorkOrderUtil.saveItem("wo.woStatus", woStatus);
    WorkOrderUtil.saveItem("wo.page", page);
    WorkOrderUtil.saveItem("wo.includeImage", includeImage);
    WorkOrderUtil.saveItem("wo.sku", sku);
    WorkOrderUtil.saveItem("wo.pcode", pcode);
    WorkOrderUtil.saveItem("wo.onlyUrgent", onlyUrgent);
    WorkOrderUtil.saveItem("wo.donMuaSearch", donMuaSearch);
    WorkOrderUtil.saveItem("wo.hanGiaoMuaSearch", hanGiaoMuaSearch);
  }

  onFilter() {
    this.clearSearchInfo();
    try{
      this.setState({spinnerVisible: true, selectedPage: 0}, () =>{ 
        this.filterOrdersBy();
      });
    }catch(e){
      this.setState({spinnerVisible: false});
    }
  }

  handleEdit(e){
    this.setState({
      selectedRow: e.viewIndex
    }, () => {
      WorkOrderUtil.saveItem('wo.selectedRow', e.viewIndex);
      if (AuthenticationService.isDesigner() || AuthenticationService.isKhac() ||
        AuthenticationService.isShipping()){
        this.props.history.push("/workOrders/design/" + e.original.id);
      }else{
        if (AuthenticationService.isWorker()){
          this.props.history.push("/workOrders/edit/" + e.original.id);
        }
      }
    });
  }

  handleFromDateChange(date){
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      fromDate: sDate                   
    }));
  }

  handleToDateChange(date){
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      toDate: sDate                   
    }));
  }

  handleHanSxChange(date){
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      fromDeadlineDate: sDate                   
    }));
  }

  handleWoStatusChange(e){
    var value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({                 
      woStatus: value                   
    }));
  }

  handleOrderNoChange(e){
    var value = e.target.value;
    WorkOrderUtil.saveItem("wo.orderNo", value)
    this.setState(prevState => ({                 
      orderNo: value                   
    }));
  }

  handleSkuChange(e){
    var value = e.target.value;
    this.setState(prevState => ({                 
      sku: value                   
    }));
  }

  handleView(e){
    this.props.history.push("/workOrders/view/" + e.original.id);
  }

  renderWoStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }

    if (AuthenticationService.isDesigner()) {
      return(
        <select onChange={this.handleWoStatusChange.bind(this)}  style={{  marginTop: '5px'}}
          value={this.state.woStatus}>
          <option value="all">{couterpart.translate('order_status_all')}</option>
          { this.state.allStatus.filter(y =>{
            return y.type === 2 && (y.status === 32 || y.status === 34 || y.status === 35 || y.status === 50 || y.status === 56 || y.status === 48 ||  y.status === 37);
          }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
        </select>
      );
    } else {
      return(
        <select onChange={this.handleWoStatusChange.bind(this)}  style={{  marginTop: '5px'}}
          value={this.state.woStatus}>
          <option value="all">{couterpart.translate('order_status_all')}</option>
          { this.state.allStatus.filter(y =>{
            return y.type === 2;
          }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
        </select>
      );
    }
  } 

  onFetch(){
    alert(1)
  }

  renderWOList () {
    if (this.state.workOrders === undefined || this.state.workOrders === null){
        return (<></>);
    }

    if (this.state.workOrders.message !== undefined) {
      return (<div className="error-msg"> { this.state.workOrders.message }</div>);
    }

    if (AuthenticationService.isDesigner()){
      return (
        <ReactTable
          manual 
          NoDataComponent={() => null} 
          previousText={"<"}
          nextText={">"}
          data={this.state.workOrders}
          columns={this.state.columnsDesigner}
          // page={this.state.page}
          onPageChange={pageIndex => {
            this.setState({ selectedPage: pageIndex }, () => {
              WorkOrderUtil.saveItem('wo.selectedPage', pageIndex);
              this.filterOrdersBy()
            })
          }}
          onPageSizeChange={(pageSize, pageIndex) => {
            this.setState({ page: pageIndex, pageSize: pageSize }, () => {
              this.filterOrdersBy()
            });
          }}        
          pages={this.state.pages}
          loading= { this.state.loading }    
          headerStyle= {{
            backgroundColor: "red",
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            left: "0px",
            padding: "12px 20px",
          }}
          getTrProps={(state, rowInfo, column) => { 
              if (rowInfo && rowInfo.row) {
                return {
                  onClick: (e) => {
                    this.setState({
                      selectedRow: rowInfo.index,
                      workOrderId: rowInfo.original.id
                    }, () => {
                      WorkOrderUtil.saveItem('wo.selectedRow', this.state.selectedRow)
                      WorkOrderUtil.saveItem('wo.selectedWorkOrderId', this.state.workOrderId)
                    })
                  },
                  style: {
                    background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                    color: rowInfo.index === this.state.selectedRow ? 'white' : 'black',
                    padding:1,
                    margin: 0,
                    borderTop: "solid 1px black"
                  }
                }
              }else{
                return {}
              }
            }
          }
          className="-striped -highlight"
          defaultPageSize = {20}
          showPageSizeOptions = {true}
          pageSizeOptions = {[3, 5, 10, 20]}
        />      
      );
    }

    return (
      <ReactTable
        manual 
        NoDataComponent={() => null} 
        previousText={"<"}
        nextText={">"}
        data={this.state.workOrders}
        columns={this.state.columns}
        // page={this.state.page}
        onPageChange={pageIndex => {
          this.setState({ selectedPage: pageIndex }, () => {
            WorkOrderUtil.saveItem('wo.selectedPage', pageIndex);
            this.filterOrdersBy()
          })
        }}
        onPageSizeChange={(pageSize, pageIndex) => {
          this.setState({ page: pageIndex, pageSize: pageSize }, () => {
            this.filterOrdersBy()
          });
        }}        
        pages={this.state.pages}
        loading= { this.state.loading }    
        headerStyle= {{
          'background-color' : 'green'
        }}
        getTrProps={(state, rowInfo, column) => { 
            if (rowInfo && rowInfo.row) {
              return {
                onClick: (e) => {
                  this.setState({
                    selectedRow: rowInfo.index,
                    workOrderId: rowInfo.original.id
                  }, () => {
                    WorkOrderUtil.saveItem('wo.selectedRow', this.state.selectedRow)
                    WorkOrderUtil.saveItem('wo.selectedWorkOrderId', this.state.workOrderId)
                  })
                },
                style: {
                  background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                  color: rowInfo.index === this.state.selectedRow ? 'white' : 'black',
                  padding:1
                }
              }
            }else{
              return {}
            }
          }
        }
        className="-striped -highlight"
        defaultPageSize = {20}
        showPageSizeOptions = {true}
        pageSizeOptions = {[3, 5, 10, 20]}
      />      
    ); 
  } 

  exportExcel(){
    try
    {

      let selectedItems = [];
      let notApprovedCount = 0;
      if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
        for (let key in this.state.selected) {
          if (this.state.selected[key].checked === true){
            if (this.state.selected[key].status !== WO_ADMIN_APPROVED){
              notApprovedCount++;
            } else {
              selectedItems.push(parseInt(key));
            }
          }
        }
      }

      if ((selectedItems.length < 1 || notApprovedCount > 0)) {
        alert(couterpart.translate('error_reviewed_items_empty_invalid'));
        return;
      }

      WorkOrderDataService.getDesignerExportedInfo(selectedItems, DATA_TYPE_DESIGN).then(existedRes => {
        console.log('getExportedInfoBy', existedRes);
        let oldExportedIds = [];
        let existedFiles = '';
        let sep = '';


        if (existedRes && existedRes.exportInfoList && existedRes.exportInfoList.length > 0){
          for(let i=0; i<existedRes.exportInfoList.length; i++){
            oldExportedIds.push(existedRes.exportInfoList[i].id);
            existedFiles += sep + existedRes.exportInfoList[i].filename;
            sep = ',';
          }
        }
        console.log(existedFiles);

        if (oldExportedIds.length > 0){
          let answ = window.confirm('Work orders ('+ existedRes.exportedWorkOrderList.join() + ') đã exported (' + existedFiles + '). Bạn có muốn export lại?');
          if(!answ){
            this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
            return;
          }
        }

        UserDataService.retrieveNextFilename(DATA_TYPE_DESIGN).then(res => {
          this.setState({spinnerVisible: true}, () =>{
            let selectedItems = [];
            if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
              for (let key in this.state.selected) {
                if (this.state.selected[key].checked === true){
                  selectedItems.push(parseInt(key));
                }
              }
            }
            // console.log("[selectedItems]: ", selectedItems);
            WorkOrderDataService.exportExcelByDesigner(selectedItems, res.filename, res.id, oldExportedIds, DATA_TYPE_DESIGN).then(data =>{
              const downloadUrl = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', res.filename);
              document.body.appendChild(link);
              link.click();
              link.remove();
              this.filterOrdersBy(); 
              this.sleep(100).then(() => {this.setState({spinnerVisible: false});});    
            });
          });
        })
     
      })       
    } catch(e) {
        this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
    }        
  }

  markExportedCK () {
    let selectedItems = [];
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true){
          selectedItems.push(parseInt(key));
        }
      }
    }

    if ((selectedItems.length < 1)) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    } 
        
    this.dialog.show({
        title: couterpart.translate("msg_title_confirm"),
        body: couterpart.translate("msg_change_wo_confirm"),
        actions: [
            Dialog.CancelAction(),
            Dialog.OKAction(() =>{
              try{
                this.setState({spinnerVisible: true}, () =>{
                  // console.log("[selectedItems]: ", selectedItems);
                  WorkOrderDataService.exportProduction(selectedItems).then(data =>{
                    this.setState({ childRefreshCount: this.state.childRefreshCount + 1}, () => {
                      this.filterOrdersBy();     
                      this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
                    })
                      
                  });
                });        
              } catch(e) {
                  this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
              }
            })
        ],
        bsSize: 'small',
        onHide: (dialog) => {
            dialog.hide()
            console.log('closed by clicking background.')
        }
    });  
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  renderItemList(){
    let options = this.state.items !== undefined?  this.state.items : []
    return(
        <>
            <input type="text" name="font" size="16" className="selectBox3"
                list="skus"
                placeholder={couterpart.translate('work_order_code')}
                defaultValue={this.state.sku}
                onChange={this.handleSkuChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleSkuChange(e) }, 0); }}/>
            <datalist id="skus">
                { options.map(x => <option value={x.sku} key={x.sku}>{x.sku}</option>) }
            </datalist>
        </>          
    );                
  }
  handlePcodeChange(e){
    let value = e.target.value;
    this.setState({                 
      pcode: value                   
    });
  }

  handleUrgentClick() {
    if (this.state.onlyUrgent === SEVERITY_URGENT) {
      this.setState({ onlyUrgent: 0 }, () => {
        this.filterOrdersBy();
      });
    } else {
      this.setState({ onlyUrgent: SEVERITY_URGENT }, () => {
        this.filterOrdersBy();
      });
    }
  }

  handleDonMuaSearchChange(e) {
    var value = e.target.value;
    this.setState({
      donMuaSearch: value
    });
  }

  handleHanGiaoMuaSearchChange(e) {
    var value = e.target.value;
    this.setState({
      hanGiaoMuaSearch: value
    });
  }

  renderDonMuaSearch() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService() && !AuthenticationService.isDesigner()  && !AuthenticationService.isShipping() && !AuthenticationService.isKhac()){
      return (<></>);
    }
    return(
      <>
        <div className="row">
          <div className="col-5">
            <input type="text" defaultValue={this.state.donMuaSearch} style={{ width: '90%', marginTop: '5px', marginLeft: '0px' }}  placeholder="Don Mua(XMAS_24)" 
              onChange={this.handleDonMuaSearchChange.bind(this)}
            />
          </div>
          <div className="col-7">
            <input type="text" defaultValue={this.state.hanGiaoMuaSearch} style={{ width: '98%', marginTop: '5px', marginLeft: '0px' }} placeholder="HanGiaoMua-yyyy/mm/dd(2024/12/13)" 
              onChange={this.handleHanGiaoMuaSearchChange.bind(this)}
            />
          </div>
        </div>
      </>
    );
  }       

  render() {
    if (AuthenticationService.isWorker()) {
      return (
        <div>
          <MenuComponent2 isChild={this.props.isChild}/>
          { this.renderWOList() }
        </div>
      );
    }else{
      return (
            <div>
                <MenuComponent2 isChild={this.props.isChild}/>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
                <br/>
                <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px'}}>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                        <div className="row">                
                          <div className="col-2"><label style={{ marginTop: '5px'}}><b>{couterpart.translate('order_date_from')}</b></label>:</div>
                          <div className="col-3">
                            <div className="customDatePickerWidth">
                              <DatePicker name="orderDateFrom"
                                dateFormat="MM/dd/yyyy hh:mm"              
                                selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                                onChange={this.handleFromDateChange.bind(this)}/></div>
                          </div>
                          <div className="col-2"><label style={{ marginTop: '5px'}}><b>{couterpart.translate('order_date_to')}</b></label>:</div>
                          <div className="col-3">
                            <div className="customDatePickerWidth">
                              <DatePicker name="orderDateTo" 
                                dateFormat="MM/dd/yyyy hh:mm"
                                selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                                onChange={this.handleToDateChange.bind(this)}/></div>
                          </div>
                        </div>
                      </div>
                      <div className="col-7 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                        <div className="row">
                          <div className="col-2"><label style={{ marginTop: '5px'}}><b>{couterpart.translate('work_orders')}</b></label></div>
                          <div className="col-3">{ this.renderWoStatusList() }</div>
                          <div className="col-3">
                            <input type="text" defaultValue={this.state.orderNo} style={{ marginTop: '5px'}}
                              placeholder={couterpart.translate('order_no')}
                              onChange={this.handleOrderNoChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }}/>
                          </div>
                          <div className="col-2">
                            <input type="text" defaultValue={this.state.pcode} style={{ width: "100%",  marginTop: '5px'}}
                              placeholder={couterpart.translate('shop_pcode')}
                              onChange={this.handlePcodeChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange(e) }, 0); }} />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            { this.renderItemList() }
                          </div>
                          <div className="col-2" style={{ paddingLeft: '5px', paddingRight: '0px', paddingTop: '5px' }}>
                            <input type="checkbox" value={2} checked={this.state.onlyUrgent == SEVERITY_URGENT ? true : false} onChange={this.handleUrgentClick.bind(this)} /> &nbsp;{couterpart.translate('work_order_urgent_by_cust')}
                          </div>
                          <div className="col-3">
                            <div  style={{ marginTop: '5px' }}>
                              { couterpart.translate('work_order_prod_deadline')}:&nbsp;
                              <DatePicker name="orderDateHanSx" 
                                dateFormat="MM/dd/yyyy hh:mm"
                                selected={ WorkOrderUtil.convertToDate(this.state.fromDeadlineDate)}
                                onChange={this.handleHanSxChange.bind(this)}/></div>
                          </div>
                          <div className="col-4">
                            { this.renderDonMuaSearch() }
                          </div>
                        </div>
                      </div>
                      <div className="col-1 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                        <div className="row">
                          <div className="col-12">  
                            <button className="myButton" 
                              onClick={this.onFilter.bind(this)}>
                              <FaFilter color={ICON_COLOR}/>
                              &nbsp;{couterpart.translate('button_filter')}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px'}}>
                  <div className="col-3">
                    &nbsp;
                  </div>
                  <div className="col-3">
                    <button className="myButton" 
                      onClick={this.exportExcel.bind(this)}>
                      <MdImportExport color={ICON_COLOR}/>
                      &nbsp;{couterpart.translate('button_export')}
                    </button>
                  </div>
                </div>
                <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />              
                { this.renderWOList() }
                <Dialog ref={(component) => { this.dialog = component }} />                
            </div>      
      )
    }
  }
}

export default withRouter(WorkOrderList);